module.exports = __webpack_public_path__ + "static/services2-fc0a337aee6e4414222c3000d9f7fb07.webp";